export default "assets/images/quotes-4222481f.png";